import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import { fetchNoticias } from "../utils/contentfulRequests";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTheme, useMediaQuery } from "@mui/material";
import CustomButton from "./CustomButton"
const CarruselNoticias = ({ height = 400 }) => {
  const [noticias, setNoticias] = useState([]);
  const theme = useTheme(); // Accede al tema global
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Verifica si el viewport es menor que "sm"

  useEffect(() => {
    const obtenerNoticias = async () => {
      const data = await fetchNoticias();
      setNoticias(data);
    };

    obtenerNoticias();
  }, []);

  const settings = {
    dots: noticias.length > 1,
    infinite: noticias.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: noticias.length > 1,
    autoplay: noticias.length > 1,
    autoplaySpeed: 10000,
  };

  const defaultImage =
    `https://via.placeholder.com/1200x${height}?text=No+Image+Available`;

  return (
    <div style={{ width: "100%", margin: "0 auto", position: "relative" }}>
      {noticias.length === 0 ? (
        <div
          style={{
            width: "100%",
            height: `${height}px`,
            display: "flex",
            alignItems: "center",
            backgroundColor: "#F5F5F5",
            color: "#666",
          }}
        >
          <p>No hay noticias disponibles en este momento.</p>
        </div>
      ) : (
        <Slider {...settings}>
          {noticias.map((noticia, index) => (
            <div key={index}>
              <div
                style={{
                  display: "flex",
                  position: "relative",
                  width: "100%",
                  height: `${height}px`,
                  background: theme.palette.primary.main,
                }}
              >
                {/* Imagen */}
                <div
                  style={{
                    flex: "0 0 70%", // Imagen ocupa 70% del ancho en desktop
                    backgroundImage: `url(${noticia.imagen || defaultImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    clipPath: "polygon(0 0, 100% 0, 85% 100%, 0% 100%)", // Diagonal
                  }}
                ></div>

                {/* Contenedor del texto */}
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: isMobile ? "50%" : "60%", // En mobile queda pegado al 50%
                    transform: isMobile 
                      ? "translate(-45%, -40%)"
                      : "translate(-50%, -50%)", // Centrado dinámico
                    backgroundColor: "rgba(0, 0, 0, 0.7)", // Fondo semitransparente
                    padding: isMobile ? "12px" : "24px", // Padding dinámico
                    color: "#FFF",
                    width: isMobile ? "90%" : "60%", // 50% en mobile, 60% en desktop
                    maxWidth: isMobile ? "450px" : "600px", // Máximo ancho en pantallas grandes
                    borderRadius: "8px",
                  }}
                >
                  <h2 style={{ marginBottom: "10px" }}>{noticia.titulo}</h2>
                  <p style={{ marginBottom: "20px" }}>{noticia.descripcion}</p>
                  <CustomButton text={noticia.textoDelBoton} onClick={() => (window.location.href = `/noticias/${noticia.slug}`)} type="orange" fontSize="16px" />
                </div>
              </div>
            </div>
          ))}
        </Slider>
      )}
    </div>
  );
};

export default CarruselNoticias;

CarruselNoticias.propTypes = {
  // height in pixels (number) or string e.g. '500' - will be converted where needed
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

